import React, {useCallback, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {appConfig} from '@stencil/hotels-config';
import SegmentSliderUI from '../../../../stories/components/hotels/HomePage/SegmentSlider/SegmentSliderUI/SegmentSliderUI';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import {fetchSegmentSliderDataThunk} from '@stencil/hotels-common-reducer/src/thunks';
import {updateQueryAction} from '@stencil/hotels-common-reducer/src/actions';
import {
  segmentSliderSelectorFn,
  destinationSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import SegmentSliderLoader from '../../../../stories/components/hotels/HomePage/SegmentSlider/SegmentSliderLoader/SegmentSliderLoader';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';

import {eventMiddlewareForFE} from '../../../utils/common-utils';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';
const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};
const {countryTextMap} = appConfig;

const SegmentSlider = ({hctxValue = ''}) => {
  const dispatch = useDispatch();
  const {isLoading: isApiLoading, data: segmentSliderData = {}, error} = useSelector(
    segmentSliderSelectorFn,
  );

  const {_id: cityId} = useSelector(destinationSelectorFn);
  const {onSearch} = useNavigateForSearchWidget();
  const segmentSliderDataRef = useRef(segmentSliderData);
  const key = hctxValue || 'common';
  const fetchSegmentSliderThunkCaller = useCallback(
    (cityId = '', hctx = '') => {
      return dispatch(fetchSegmentSliderDataThunk(cityId, hctx, key));
    },
    [dispatch],
  );

  const updateQueryActionCaller = useCallback(data => dispatch(updateQueryAction(data)), [
    dispatch,
  ]);

  useEffect(() => {
    segmentSliderDataRef.current = segmentSliderData;
  }, [segmentSliderData]);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    if (!segmentSliderDataRef?.current[key] && !error) {
      fetchSegmentSliderThunkCaller(cityId, hctxValue);
    }
  });

  const sliderClicksGAHandler = index => {
    pushga({
      eventCategory: HomePageGAEvents.sliderClicks.category,
      eventAction: HomePageGAEvents.sliderClicks.action.segmentSliderClicked(
        hctxValue || 'gostays',
      ),
      eventLabel: index,
    });
  };

  const hasSegmentSliderData =
    segmentSliderData &&
    segmentSliderData[key] &&
    segmentSliderData[key].data_list &&
    segmentSliderData[key].data_list.length > 0 &&
    segmentSliderData[key]?.data_list[0].data;

  return (
    <div ref={watcherRef} style={{width: '100%'}}>
      {(isApiLoading && <SegmentSliderLoader />) ||
        (hasSegmentSliderData && (
          <SegmentSliderUI
            actionHandler={(data, country) => {
              updateQueryActionCaller({
                country:
                  country === countryTextMap.india.value.toLowerCase()
                    ? countryTextMap.india.key
                    : countryTextMap.international.key,
              });
              onSearch({openInNewTab: true, hotelData: data});
            }}
            data={segmentSliderData[key]}
            eventMiddlewareForFE={eventMiddlewareForFE}
            sliderClicksGAHandler={sliderClicksGAHandler}
            goSafePersuasionTemplateId={appConfig.persuasionsTemplateIds.goSafe}
          />
        )) ||
        null}
    </div>
  );
};

export default SegmentSlider;
